import houseExpropriation from '@/page/house-expropriation'
import About from '@/page/about'
import Case from '@/page/case'
import caseDetail from '@/page/caseDetail'
import News from '@/page/news'
import Product from '@/page/product'
import Service from '@/page/service'
import wholeProcess from '@/page/whole-process'
import Collection from '@/page/collection'
import Expropriated from '@/page/expropriated-account'
import expropriatedClient from '@/page/expropriated-client'
import fullProcess from '@/page/full-process-collection'
import fileManagement from '@/page/file-management'
import panoramicAerialPhotography from '@/page/panoramic-aerial-photography'
import newsDetail from '@/page/newsDetail'
import Application from '@/page/application'
import Gis from '@/page/gis'
import gisOther from '@/page/gis-other'
export default [
    {
        path: '/public',
        name: 'public',
        component: houseExpropriation
    },
    {
        path: '/about',
        name: 'about',
        component: About
    },
    {
        path: '/case',
        name: 'case',
        component: Case
    },
    {
        path: '/news',
        name: 'news',
        component: News
    },
    {
        path: '/news/newsDetail/:Id',
        name: 'newsDetail',
        component: newsDetail
    },
    {
        path: '/product',
        name: 'product',
        component: Product
    },
    {
        path: '/service',
        name: 'service',
        component: Service
    },
    {
        path: '/whole',
        name: 'whole',
        component: wholeProcess
    },
    {
        path: '/collection',
        name: 'collection',
        component: Collection
    },
    {
        path: '/expropriated',
        name: 'Expropriated',
        component: Expropriated
    },
    {
        path: '/client',
        name: 'Client',
        component: expropriatedClient
    },
    {
        path: '/process',
        name: 'process',
        component: fullProcess
    },
    {
        path: '/management',
        name: 'management',
        component: fileManagement
    },
    {
        path: '/panoramic',
        name: 'panoramic',
        component: panoramicAerialPhotography
    },
    {
        path: '/case/caseDetail/:Id',
        name: 'caseDetail',
        component: caseDetail
    },
    {
        path: '/application',
        name: 'application',
        component: Application
    },
    {
        path: '/gis',
        name: 'gis',
        component: Gis
    },
    {
        path: '/gisOther',
        name: 'gisOther',
        component: gisOther
    }
];



// WEBPACK FOOTER //
// ./src/router/application.js